import React, { ReactNode } from 'react';
import './TertiaryButton.scss';
import { FaIcon, FaIcons } from '@innovationnorway/component-library';
import classNames from 'classnames';
import { IconLookup, findIconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Button } from '@innovationnorway/cl-react';

// Sizes available in utilities.scss
type InSize =
  | 'x-small'
  | 'small'
  | 'medium'
  | 'large'
  | 'x-large'
  | 'xx-large'
  | '2rem'
  | '20px'
  | '40px'
  | '3rem';

function TertiaryButton(props: {
  children?: ReactNode;
  icon?: IconLookup;
  onClick?: () => void;
  standardizedSize?: InSize | false;
  minimalPadding?: boolean;
  className?: string;
  ariaLabel?: string;
  iconRight?: boolean;
  faIcon?: FaIcons;
  disabled?: boolean;
  selected?: boolean;
}) {
  const fontSize = props.standardizedSize ?? 'medium';

  //Backwards compatibility for datatables
  const IconToShow = () => {
    return props.faIcon ? (
      <FaIcon
        name={props.faIcon}
        // The size should match the fontSize of the button, not be overriden by FaIcon logic
        // This is a workaround as FaIcon forces a static font-size
        size={'none' as any}
      />
    ) : props.icon ? (
      <FaIcon icon={findIconDefinition(props.icon)} />
    ) : (
      <></>
    );
  };

  return (
    <Button
      variant="tertiary"
      className={classNames(
        'tertiary-button',
        fontSize && `font-size--${fontSize}`,
        props.minimalPadding && 'minimal-padding',
        props.selected && 'selected',
        props.className,
      )}
      disabled={props.disabled}
      aria-label={props.ariaLabel}
      type="button"
      onClick={props.onClick}
    >
      <span>
        {(props.icon || props.faIcon) && !props.iconRight && <IconToShow />}
        {props.children}
        {(props.icon || props.faIcon) && props.iconRight && <IconToShow />}
      </span>
    </Button>
  );
}

export default TertiaryButton;
